var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "auth-terms",
    },
    [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.confirmPara) } }),
      _vm._v(" "),
      _c(
        "el-checkbox",
        {
          model: {
            value: _vm.agree,
            callback: function ($$v) {
              _vm.agree = $$v
            },
            expression: "agree",
          },
        },
        [_vm._v(_vm._s(_vm.confirmAgreement) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: "Authentication failed",
              type: "error",
              description: _vm.error,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "btn-confirm",
          attrs: { type: "primary", disabled: !_vm.agree },
          on: { click: _vm.acceptTerms },
        },
        [_vm._v("Continue")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }